export const HEADER_TYPE_MODALS = {
  MAIN: 'MAIN',
  SECONDARY: 'SECONDARY'
} as const;

export type ModalHeaderType =
  (typeof HEADER_TYPE_MODALS)[keyof typeof HEADER_TYPE_MODALS];

export type HeaderMainModalProps = {
  onModalClose?: () => void;
  contentTitle?: string;
};

export type HeaderSecondaryModalProps = {
  onBack?: () => void;
  contentTitle: string;
};

export type HeaderModalVariant =
  | ({ type: typeof HEADER_TYPE_MODALS.MAIN } & HeaderMainModalProps)
  | ({ type: typeof HEADER_TYPE_MODALS.SECONDARY } & HeaderSecondaryModalProps);
